import { Injectable, inject } from '@angular/core';
import { environment } from '@env/environment';

import { SettingsService } from './settings.service';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  private settingsService = inject(SettingsService);

  getVersion(): string {
    return environment.version;
  }
  getFullVersion(): string {
    return environment.fullVersion;
  }
}
